import { connect } from 'react-redux';
import { IState } from '../../../store';

import {
  BuildingGarageLandCard,
  IBuildingGarageLandCardProps,
  IBuildingGarageLandCardStoreProps,
} from './buildingGarageLand';

export function mapStateToProps(state: IState): IBuildingGarageLandCardStoreProps {
  const {
    experiments,
    isStalkerBannerShown,
    isBrandingAvailable,
    hideOffer: { status, errorMessage, isTopPopupOpened },
    offerData: { offer, user, isHiddenByUser },
    showAnalyticsButton,
  } = state;

  const isAnalyticsButtonShown = showAnalyticsButton && offer.cianId % 3 === 0;

  return {
    experiments,
    offer,
    isUserAuthenticated: user && user.isAuthenticated,
    isStalkerBannerShown,
    isBrandingAvailable,
    hideOfferStatus: status,
    hideOfferErrorMessage: errorMessage,
    isTopPopupOpened,
    isHiddenByUser,
    isAnalyticsButtonShown,
  };
}

export const BuildingGarageLandCardContainer = connect<
  IBuildingGarageLandCardStoreProps,
  {},
  IBuildingGarageLandCardProps
>(mapStateToProps)(BuildingGarageLandCard);
